import Card from '@mui/material/Card';
import { CardHeader, CardContent, Divider, Table, TableCell, TableContainer, TableHead, TableBody, TableRow, TablePagination, Typography, Button, Backdrop, CircularProgress, Snackbar, Dialog, DialogTitle, DialogContent, IconButton, Box, Chip } from '@mui/material';
import { getUser } from 'src/utils/Common';
import axios from 'src/utils/axios';
import React, { useEffect, useState } from 'react';
import Alert from 'src/components/Alert';
import moment from 'moment';
import CloseIcon from '@mui/icons-material/Close';

function ReportMonitoring() {

  const SessionUser = getUser();
  const [reportData, setReportData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [detailPopup, setDetailPopup] = React.useState(false);
  const [renk, setRenk] = React.useState('black');
  const [detailData, setDetailData] = React.useState([]);
  const [detailDataParametres, setDetailDataParametres] = React.useState([]);
  const [kulparamArrays, setKulparamArrays] = React.useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  useEffect(() => {
    handleReportMonitoring();
  }, []);

  const handleReportMonitoring = () => {
    HandleChangeColorResetClick();
    setLoading(true);
    axios.get(`GetReportMonitoring/${SessionUser.TopServiceShopCode}`)
      .then((response) => {
        setLoading(false);
        var data = response.data;
        setReportData(Array.isArray(data) ? data : []);
        setPage(0);
      }).catch((error) => {
        setLoading(false);
        return;
      });
  };

  const handleReportDetail = (Id) => {
    setDetailPopup(true);
    setLoading(true);
    axios.get(`GetSarisReportDetail/${Id}`)
      .then((response) => {
        setLoading(false);
        var data = response.data[0];
        setDetailData(data)
      }).catch((error) => {
        setLoading(false);
        return;
      });
    setLoading(true);
    axios.get(`GetSarisReportDetailParametres/${Id}`)
      .then((response) => {
        setLoading(false);
        var datax = response.data;
        const newData = response.data[0].KULPARAM
        const kulparam = newData;
        const kulparamArray = kulparam.split(',');
        setKulparamArrays(kulparamArray)
        setDetailDataParametres(Array.isArray(datax) ? datax : []);
      }).catch((error) => {
        setLoading(false);
        return;
      });
  }

  const handleButtonClick = (Id) => {
    setLoading(true);
    axios.get(`SarisReportDelete/${Id}`)
      .then((response) => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == "1000") {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          return;
        }
        else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          return;
        }
      }).catch((error) => {
        setLoading(false);
        return;
      });
  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function HandleChangeColorClick(Color) {
    setRenk({ ...renk, [Color]: '#0033a0' });
  }
  function HandleChangeColorResetClick() {
    setRenk('black');
  }

  function HandleResertAndClose() {
    setDetailPopup(false);
    setKulparamArrays([]);
    setDetailDataParametres([]);
    setDetailData([]);
  }

  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Card>
        <Backdrop sx={(theme) => ({ zIndex: theme.zIndex.drawer + 1, color: '#fff' })} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <CardHeader
          title="Rapor İzleme"
          subheader="Silmek istediğiniz rapor isteğini İPTAL seçeneği ile silebilirsiniz."
        />
        <Divider />
        <CardContent>
          <TableContainer>
            <Table size='medium'>
              <TableHead>
                <TableRow>
                  <TableCell align='center' sx={{ fontWeight: 700 }}>No</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Açıklama</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Kullanıcı</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>İstek Tarihi</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Durum</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>İptal</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  reportData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                    <TableRow hover key={row.ID}>
                      <TableCell align="center">
                        <Chip
                          label={row.ID}
                          size="small"
                          variant={renk[row.ID] ? 'filled' : 'outlined'}
                          clickable
                          onClick={() => { handleReportDetail(row.ID); HandleChangeColorClick(row.ID); }}
                        />
                      </TableCell>
                      <TableCell>{row.RAPORTANIM}</TableCell>
                      <TableCell>{row.ADSOYAD}</TableCell>
                      <TableCell>{moment(row.VERILIS_TARIHI).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                      <TableCell>{row.DURUM_ACIKLAMA}</TableCell>
                      <TableCell>
                        {row.DURUM === 0 ? (
                          <Button variant="contained" color="secondary" size="small" onClick={() => handleButtonClick(row.ID)}>
                            İptal
                          </Button>
                        ) : (
                          '-'
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={reportData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          <Typography align='center' variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
            Son 50 istek listelenmiştir.
          </Typography>
        </CardContent>
      </Card>
      <Dialog
        open={detailPopup}
        onClose={HandleResertAndClose}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Rapor Detayı
          <IconButton aria-label="close" size="small" onClick={() => { HandleResertAndClose(); }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <TableContainer>
            <Table size='medium'>
              <TableHead>
                <TableRow>
                  <TableCell align='center' sx={{ fontWeight: 700 }}>Rapor İstek No</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Durum</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Rapor Tanım</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>İstek Tarihi</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Durum Tarihi</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Raporu İsteyen</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>E-mail</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow hover key={detailData?.ID}>
                  <TableCell>{detailData?.ID}</TableCell>
                  <TableCell>{detailData?.DURUM_ACIKLAMA}</TableCell>
                  <TableCell>{detailData?.RAPORTANIM}</TableCell>
                  <TableCell>{moment(detailData?.VERILIS_TARIHI).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                  <TableCell>{moment(detailData?.ISTEK_TARIHI).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                  <TableCell>{detailData?.ADSOYAD}</TableCell>
                  <TableCell>{detailData?.EMAIL}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ mt: 3 }}>
            <TableContainer>
              <Table size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700 }}>Sıra No</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Değişken Adı</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Parametreler</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {detailDataParametres?.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.SIRA_NO}</TableCell>
                      <TableCell>{row.DEGISKEN_ADI}</TableCell>
                      <TableCell>{kulparamArrays[index]}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );

}

export default ReportMonitoring;
